if (!customElements.get('page-banner-nav')) {
  class PageBannerNav extends customElements.get('sticky-nav') {
    constructor() {
      super();

      this.header = document.querySelector(
        '#shopify-section-header header, .shopify-section-group-header-group header',
      );
      this.links = this.querySelectorAll('[data-link]');
      this.checkpoints = Array.from(
        document.querySelectorAll('[data-nav-checkpoint]'),
      );
    }

    connectedCallback() {
      super.connectedCallback();

      this.setActiveLink();

      window.addEventListener('hashchange', () => {
        this.setActiveLink();
      });

      ['scroll', 'resize'].forEach((eventName) => {
        window.addEventListener(
          eventName,
          debounce(() => {
            this.setActiveCheckpoint();
          }, 100),
        );
      });
    }

    setActiveCheckpoint() {
      const activeHeading = this.checkpoints.findLast((checkpoint) => {
        const offset = 15;
        const topValue =
          checkpoint.getBoundingClientRect().y -
          this.header.offsetHeight -
          this.offsetHeight -
          offset;

        return topValue <= 0;
      });

      history.replaceState(null, '', `#${activeHeading?.id || ''}`);
      this.setActiveLink();
    }

    setActiveLink() {
      this.links.forEach((link) => {
        const isActive = window.location.hash === link.hash;

        link.classList.toggle('is-active', isActive);
      });
    }
  }

  customElements.define('page-banner-nav', PageBannerNav);
}
